<mat-sidenav-container class="main-container tw-h-full uw-layout">
  <mat-sidenav [mode]="sidenavMode" [opened]="sidenav" class="sidenav  ">
    <div class="uw-layout-header">
      <a class="uw-nav-logo tw-flex-grow" routerLink="/">
        <img [src]="logoUrl()" [alt]="brandName()" class="uw-brand-logo" />
      </a>
      <button mat-icon-button (click)="sidenav=!sidenav"><mat-icon>menu</mat-icon></button>
    </div>
    <div class="tw-flex tw-flex-col tw-flex-1 tw-overflow-y-auto">
      <nav class="tw-flex tw-flex-col tw-gap-1 tw-flex-1 tw-py-2 ">
        @switch (area) {
        @case('admin') {
        <a routerLink="/admin/status" routerLinkActive="uw-active">
          <i class="pi pi-chart-line"></i> {{brandName()}} Status
        </a>
        <a routerLink="/admin/users" routerLinkActive="uw-active">
          <i class="pi pi-users"></i> Manage Users
        </a>
        @if(user?.roles?.includes('super-admin') || user?.roles?.includes('operator')) {
        <a routerLink="/admin/generic-event-deliveries" routerLinkActive="uw-active">
          <i class="pi pi-send"></i> Event Deliveries
        </a>
        <a routerLink="/admin/reporting-events" routerLinkActive="uw-active">
          <i class="pi pi-database"></i> Reporting Events
        </a>
        }
        @if(user?.roles?.includes('super-admin')){
        <a routerLink="/admin/phone-inventory" routerLinkActive="uw-active"><i class="pi pi-phone"></i> Twilio inventory</a>
        <!-- <a routerLink="/admin/workspaces" routerLinkActive="uw-active">
          <i class="pi pi-building"></i> Manage Workspaces
        </a> -->
        <a routerLink="/admin/campaigns" routerLinkActive="uw-active">
          <i class="pi pi-chart-line"></i> Manage Campaigns
        </a>
        <a routerLink="/admin/calls" routerLinkActive="uw-active">
          <i class="pi pi-phone"></i> Call Logs
        </a>
        <a routerLink="/admin/call-costs" routerLinkActive="uw-active">
          <i class="pi pi-dollar"></i> VOXR Cost Report
        </a>
        <a routerLink="/admin/reports" routerLinkActive="uw-active">
          <i class="pi pi-chart-pie"></i> Call Reports
        </a>
        <a routerLink="/admin/billing-snapshots" routerLinkActive="uw-active">
          <i class="pi pi-table"></i> Billing Snapshots
        </a>
        <a routerLink="/admin/calls-timeline" routerLinkActive="uw-active">
          <i class="pi pi-clock"></i> Call Timeline
        </a>
        <a routerLink="/admin/owner-performance" routerLinkActive="uw-active">
          <i class="pi pi-chart-line"></i> Accounts Performance
        </a>
        }
        <a routerLink="/admin/vapi" routerLinkActive="uw-active" class="tw-mt-auto">
          <i class="pi pi-link"></i> Manage VAPI
        </a>
        @if(user?.roles?.includes('super-admin')){
        <a routerLink="/admin/plans" routerLinkActive="uw-active">
          <i class="pi pi-link"></i> Manage Plans
        </a>
        <a routerLink="/admin/integrations" routerLinkActive="uw-active">
          <i class="pi pi-link"></i> Default Integrations
        </a>
        <a routerLink="/admin/webhook-presets" routerLinkActive="uw-active">
          <i class="pi pi-send"></i> Webhook Presets
        </a>
        <a routerLink="/admin/blueprints" routerLinkActive="uw-active">
          <i class="pi pi-book"></i> Built-in Blueprints
        </a>
        <a routerLink="/admin/campaign-templates" routerLinkActive="uw-active">
          <i class="pi pi-chart-line"></i> Verticals &amp; Templates
        </a>
        @for (link of adminSystemLinks; track link.path) {
        <a [routerLink]="link.path" routerLinkActive="uw-active">
          <i class="pi {{link.icon}}"></i> {{link.label}}
        </a>
        }
        }

        }
        @case('account') {
        <a routerLink="/account/status" routerLinkActive="uw-active">
          <i class="pi pi-chart-line"></i> Account Status
        </a>
        @if(user?.isApproved || user?.onboarded?.includes('complete')) {
        <a routerLink="/account/billing-cost" routerLinkActive="uw-active">
          <i class="pi pi-money"></i> Billing & Cost Reports
        </a>
        <a routerLink="/account/phone" routerLinkActive="uw-active">
          <i class="pi pi-phone"></i> Phone Settings
        </a>
        <a routerLink="/account/workspaces" routerLinkActive="uw-active">
          <i class="pi pi-shop"></i> Workspaces
        </a>
        <a routerLink="/account/integration" routerLinkActive="uw-active">
          <i class="pi pi-link"></i> Integrations
        </a>
        <!-- <a routerLink="/account/api-keys" routerLinkActive="uw-active">
          <i class="pi pi-link"></i> API Keys
        </a> -->
        }

        }
        @case('reseller') {
        <a routerLink="/reseller/status" routerLinkActive="uw-active">
          <i class="pi pi-chart-line"></i> Reseller Status
        </a>
        @if(user?.resellerConfig?.whiteLabel?.enabled) {
        <a routerLink="/reseller/whitelabel" routerLinkActive="uw-active">
          <i class="pi pi-cog"></i> White-Label Settings
        </a>
        @if(user?.resellerConfig?.whiteLabel?.domains?.length) {
        <ng-template #resellerLink let-link="link" let-externalResellerDomain="externalResellerDomain" let-icon="icon"
          let-text="text">
          @if(externalResellerDomain) {
          <a [href]="externalResellerDomain+link" target="_blank" title="{{link}}">
            <i class="pi {{icon}}"></i> {{text}}
          </a>
          } @else {
          <a [routerLink]="link" routerLinkActive="uw-active">
            <i class="pi {{icon}}"></i> {{text}}
          </a>
          }
        </ng-template>
        <ng-container
          *ngTemplateOutlet="resellerLink; context: { link: '/reseller/plans', externalResellerDomain: externalResellerDomain, icon: 'pi-shop', text: 'Manage Plans' }"></ng-container>
        <ng-container
          *ngTemplateOutlet="resellerLink; context: { link: '/reseller/users', externalResellerDomain: externalResellerDomain, icon: 'pi-users', text: 'Manage Users' }"></ng-container>
        <ng-container
          *ngTemplateOutlet="resellerLink; context: { link: '/reseller/blueprints', externalResellerDomain: externalResellerDomain, icon: 'pi-book', text: 'Built-in Blueprints' }"></ng-container>
        <ng-container
          *ngTemplateOutlet="resellerLink; context: { link: '/reseller/campaign-templates', externalResellerDomain: externalResellerDomain, icon: 'pi-chart-line', text: 'Campaign Templates' }"></ng-container>
        <ng-container
          *ngTemplateOutlet="resellerLink; context: { link: '/reseller/phone', externalResellerDomain: externalResellerDomain, icon: 'pi-phone', text: 'Phone Settings' }"></ng-container>
        <ng-container
          *ngTemplateOutlet="resellerLink; context: { link: '/reseller/workspaces', externalResellerDomain: externalResellerDomain, icon: 'pi-shop', text: 'Lite Workspaces' }"></ng-container>
        }
        } @else {
        <a [routerLink]="'/reseller/plans'" routerLinkActive="uw-active">
          <i class="pi pi-shop"></i> Manage Plans</a>
        <a [routerLink]="'/reseller/users'" routerLinkActive="uw-active">
          <i class="pi pi-users"></i> Manage Users</a>
        <a [routerLink]="'/reseller/blueprints'" routerLinkActive="uw-active">
          <i class="pi pi-book"></i> Built-in Blueprints</a>
        <a [routerLink]="'/reseller/campaign-templates'" routerLinkActive="uw-active">
          <i class="pi pi-chart-line"></i> Campaign Templates</a>
        <a [routerLink]="'/reseller/phone'" routerLinkActive="uw-active">
          <i class="pi pi-phone"></i> Phone Settings</a>
        <a [routerLink]="'/reseller/workspaces'" routerLinkActive="uw-active">
          <i class="pi pi-shop"></i> Workspaces</a>
        }
        }
        @case('affiliate') {
        <a routerLink="/affiliate/status" routerLinkActive="uw-active">
          <i class="pi pi-chart-line"></i> Affiliate Status
        </a>
        @if(user?.affiliateConfig?.permissions?.includes('affiliate-users-manage') ||
        user?.affiliateConfig?.permissions?.includes('affiliate-workspaces-manage')){
        <a routerLink="/affiliate/users" routerLinkActive="uw-active">
          <i class="pi pi-users"></i> Users
        </a>
        }
        }
        @case('workspace') {
        @if(!coachOnly) {
        <a wRouterLink="/campaigns" routerLinkActive="uw-active">
          <i class="pi pi-chart-line"></i> Campaigns
        </a>
        }
          <a wRouterLink="/agent-tasks" routerLinkActive="uw-active">
            <i class="pi pi-list"></i> Agent Tasks
          </a>
        @if(!coachOnly) {
        @let walletBalance = walletService.balance();
        <a wRouterLink="/wallet" routerLinkActive="uw-active" data-testid="sidebar-wallet">
          <i class="pi pi-wallet"></i> Wallet
          @if(walletBalance !== null) {
          <span class="uw-tag" [class.uw-tag-secondary]="walletBalance >= 0" [class.uw-tag-danger]="walletBalance < 0"
            data-testid="sidebar-wallet-balance">{{formatCredits(walletBalance)}} credits</span>
          }
        </a>
        }
        @if(canViewLiveTransfers()) {
        <a wRouterLink="/live-transfers" routerLinkActive="uw-active">
          <i class="pi pi-headphones"></i> Live Transfers
        </a>
        }
        @if(workspace?._metadata?.adminAccess) {

        <a wRouterLink="/reporting-events" routerLinkActive="uw-active">
          <i class="pi pi-database"></i> Reporting Events
        </a>

        @if(!workspace?.onboarded?.includes('completed')){
        <a wRouterLink="/onboarding" routerLinkActive="uw-active">
          <i class="pi pi-star"></i> Onboarding
        </a>
        }
        <a wRouterLink="/assistants" routerLinkActive="uw-active">
          <i class="pi pi-bolt"></i> Assistants
        </a>
        <a wRouterLink="/calls" routerLinkActive="uw-active">
          <i class="pi pi-phone"></i> Call Logs
        </a>
        <div class="tw-flex-grow"></div>
        <a wRouterLink="/blueprints" routerLinkActive="uw-active">
          <i class="pi pi-book"></i> Blueprints
        </a>
        <a wRouterLink="/integration" routerLinkActive="uw-active">
          <i class="pi pi-link"></i> Integrations
        </a>
        @if(user?.roles?.includes('super-admin')){
        <a wRouterLink="/generic-event-deliveries" routerLinkActive="uw-active">
          <i class="pi pi-send"></i> Event Deliveries
        </a>
        }
        @if(user?.roles?.includes('super-admin')){
        <a wRouterLink="/api-keys" routerLinkActive="uw-active">
          <i class="pi pi-link"></i> API Keys
        </a>
        }
        <a wRouterLink="/members" routerLinkActive="uw-active">
          <i class="pi pi-users"></i> Workspace Members
        </a>
        <a wRouterLink="/offerings" routerLinkActive="uw-active">
          <i class="pi pi-shopping-bag"></i> Offerings
        </a>
        <a wRouterLink="/settings" routerLinkActive="uw-active">
          <i class="pi pi-cog"></i> Workspace Settings
        </a>
        @if(user?.roles?.includes('super-admin')){
        <a wRouterLink="/reports" routerLinkActive="uw-active">
          <i class="pi pi-chart-line"></i> Reports
        </a>
        }
        } @else { <div class="tw-flex-grow"></div> }

        @if(workspaces?.length && workspaces!.length > 1){
        <mat-form-field appearance="outline" class="tw-w-full">
          <mat-label>Select Workspace</mat-label>
          <mat-select [ngModel]="workspace?._id?.toString()" (ngModelChange)="setWorkspace($event)">
            @for (workspaceOption of workspaces; track workspaceOption._id.toString()) {
            <mat-option [value]="workspaceOption._id.toString()">{{workspaceOption.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        }

        }
        }

      </nav>

    </div>
  </mat-sidenav>
  <mat-sidenav-content>
    <div class="tw-flex tw-flex-col tw-flex-1 tw-flex-grow tw-min-w-0 tw-h-full tw-overflow-hidden">
      <div class="uw-layout-header">
        @if(!sidenav){
        <button mat-icon-button (click)="sidenav=!sidenav" class="tw-p-4 tw-m-2 tw-cursor-pointer">
          <mat-icon>menu</mat-icon>
        </button>
        }
        @switch (area) {
        @case('workspace') {
        <div class="tw-flex tw-gap-2 tw-items-center tw-px-4">
          @if(workspace) {
          <div class="tg-page-header tw-whitespace-nowrap tw-overflow-ellipsis"
            [ngClass]="{'text-danger tw-italic': workspace!._metadata!.adminAccess && !['owner','admin'].includes(workspace!._metadata!.adminAccess) }">
            {{workspace.name}}
            @switch(workspace._metadata!.adminAccess) {
            @case('super-admin'){<div class="uw-tag uw-tag-danger">(Super Admin)</div>}
            @case('reseller'){<div class="uw-tag uw-tag-danger">(Reseller Access)</div>}
            @case('affiliate'){<div class="uw-tag uw-tag-danger">(Affiliate Access)</div>}
            }
          </div>
          @if(workspace.accountStatus != 'active') {
          @if(canceledSubscriptionStatuses.includes($any(workspace.accountStatus))) {
          <div class="uw-tag uw-tag-danger" [matTooltip]="workspace.accountStatus">Account Disabled</div>
          } @else {
          <div class="uw-tag uw-tag-warning" [matTooltip]="workspace.accountStatus">Action Required</div>
          }
          @if(workspace.ownerId == user?._id?.toString()) {
          <a routerLink="/account/onboarding" class="tw-ml-2">Activate Account</a>
          }
          }
          }
        </div>
        <app-connection-stats />
        }
        @case('account') {
        <div class="tg-page-header">Account Settings</div>
        }
        @case('reseller') {
        <div class="tg-page-header">Reseller Settings</div>
        }
        @case('admin') {
        <div class="tg-page-header">Admin Area</div>
        }
        }
        <div class="tw-flex-grow"></div>
        @if(area === 'workspace' && workspace && activeCoachTransfer()) {
        <app-transfer-coach [transfer]="activeCoachTransfer()!" (left)="onCoachLeft()" />
        }
        <app-user-status />
      </div>
      <div class="uw-layout-content">
        <router-outlet />
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
